import { apiAction, apiFetch, getMetaContent } from 'utils';
import DuckEntity from './DuckEntity';
import PageableDuck from './PageableDuck';

const duck = new PageableDuck(new DuckEntity('billingImportJobs'));

const create = ({ importFile, description, dryRun }) => {
  let token = getMetaContent('csrf-token');

  const headers = { Accept: 'application/json', 'X-CSRF-Token': token };
  const actionParams = { import_file: importFile, description, dry_run: dryRun };
  const data = new FormData();
  data.append('import_file', importFile);
  data.append('description', description);
  data.append('dry_run', dryRun);

  return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => apiFetch.post(state, 'billing_import_jobs', null, { rawBody: data, headers }),
    actionParams
  );
};

export const billingImportJobs = {
  ...duck,
  actions: {
    ...duck.actions,
    create
  }
};

export default billingImportJobs.reducer;
